/* eslint-disable */
import Oidc from 'oidc-client-zqy';
import 'babel-polyfill';
import {
  authUrl,loginUrl
} from '../js/version';
var mgr = new Oidc.UserManager({
  userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
  authority: authUrl,
  client_id: "managervuejs",
  // redirect_uri: window.location.origin + '/static/callback.html',
  redirect_uri: loginUrl + '/#/callback/?',
  response_type: 'id_token token',
  scope: "openid profile role manager.api UserState tenant.api",
  post_logout_redirect_uri: loginUrl,
  silent_redirect_uri: loginUrl + '/static/silent-renew.html',
  accessTokenExpiringNotificationTime: 10,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  extraQueryParams:{InAuth:loginUrl +'/#/login/unloading',
  Disabled:loginUrl +'/#/login/disabled',
  IpLimited:loginUrl +'/#/login/iplimited',
  AccessDenied:loginUrl +'/#/accessdenied',
  IpSecurity:loginUrl +'/#/login/ipsecurity',
  Deleted:loginUrl +'/#/login/deleted'},
  loadUserInfo: true
})

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.INFO;

// mgr.events.addUserLoaded(function (user) {  
//   console.log('New User Loaded：', arguments);
//   console.log('Acess_token: ', user.access_token)
// });

// mgr.events.addAccessTokenExpiring(function () {
//   console.log('AccessToken Expiring：', arguments);
// });

// mgr.events.addAccessTokenExpired(function () {
//   //   alert('会话超时，请重新登录!');
//   //   this.manager.removeUser().then(() => {
//   //     this.user = null;
//   //     this.authNavStatusSource.next(false);
//   //     this.router.navigate(["login"]);
//   //   });
//   mgr.signoutRedirect().then(function (resp) {
//     console.log('signed out', resp);
//   }).catch(function (err) {
//     console.log(err)
//   })
//   });

// mgr.events.addSilentRenewError(function () {
//   console.error('Silent Renew Error：', arguments);
// });

// mgr.events.addUserSignedOut(function () {
//   // alert('Going out!');
//   console.log('UserSignedOut：', arguments);  
//   mgr.signoutRedirect().then(function (resp) {
//     console.log('signed out', resp);
//   }).catch(function (err) {
//     console.log(err)
//   })
// });

export default class SecurityService {

  // Renew the token manually
  renewToken () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.signinSilent().then(function (user) {
        if (user == null) {
          self.signIn(null)
        } else{
          return resolve(user)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }

  // Get the user who is logged in
  getUser () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }

  // Check if there is any user logged in
  getSignedIn () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null||user.expired) {
         // self.signIn()
          return resolve(false)
        } else{
          return resolve(true)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }

  // Redirect of the current window to the authorization endpoint.
  signIn () {
    mgr.signinRedirect().catch(function (err) {
      console.log(err)
    })
  }
  
  // Redirect of the current window to the end session endpoint
  signOut () {    
    mgr.signoutRedirect().then(function (resp) {
      console.log('signed out', resp);
    }).catch(function (err) {
      console.log(err)
    })
  }

  // Get the profile of the user logged in
  getProfile () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.profile)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }

  // Get the token id
  getIdToken(){
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.id_token)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }

  // Get the session state
  getSessionState(){
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.session_state)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }

  // Get the access token of the logged in user
  getAcessToken(){
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.access_token)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }

  // Takes the scopes of the logged in user
  getScopes(){
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.scopes)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }

  getRole() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null||user.expired) {
          self.signIn().then(rsq => {
            if (user == null) {
              return resolve(null)
            } else {
              return resolve(user.profile.role)
            }
          }).catch(err => {
            return resolve(null)
          })
        } else {    
            return resolve(user.profile.role)          
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }

  popupLayer(){
    let self = this;
    mgr.getSigninRedirectUrl().then(u=>{
      layer.open({
        type: 2,
        title: '',
        skin: 'layui-layer-lan',
        shadeClose: true,
        shade: 0.5,
        area: ['584px', '674px'],
        id:'login',
        content: u,//iframe的url
        end: function(){
          self.getSignedIn().then(result => {
            if(result){
              window.location.href='../#/home'
            }
          });         
        }
      }); 
    })
  }


}
